import { useState } from "react";
import { Building2, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

const EMPTY = { nome: "", indirizzo: "", citta: "" };

export const PropertiesCard = ({ properties, onChange }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/properties", form);
      toast.success("Immobile aggiunto");
      setForm(EMPTY);
      setOpen(false);
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/properties/${id}`);
      toast.success("Immobile rimosso");
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <section className="surface p-6" data-testid="properties-card">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-[#0f172a]">Immobili</h2>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><button data-testid="button-add-property" className="btn-ghost px-3 py-1.5"><Plus className="h-4 w-4" />Aggiungi</button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuovo immobile</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-4">
              <div><label className="field-label">Nome</label><input data-testid="input-property-nome" required className="field-input" placeholder="es. Bilocale centro" value={form.nome} onChange={set("nome")} /></div>
              <div><label className="field-label">Indirizzo</label><input data-testid="input-property-indirizzo" required className="field-input" placeholder="es. Via Roma 12" value={form.indirizzo} onChange={set("indirizzo")} /></div>
              <div><label className="field-label">Città</label><input data-testid="input-property-citta" required className="field-input" placeholder="es. Milano" value={form.citta} onChange={set("citta")} /></div>
              <button data-testid="button-save-property" type="submit" className="btn-accent w-full">Salva immobile</button>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <ul className="mt-5 space-y-2">
        {properties.length === 0 && <li className="rounded-xl border border-dashed border-slate-300 p-5 text-center text-sm text-slate-500">Nessun immobile. Aggiungine uno per iniziare.</li>}
        {properties.map((p) => (
          <li key={p.id} data-testid={`property-item-${p.id}`} className="group flex items-start gap-3 rounded-xl border border-slate-200 p-3.5">
            <Building2 className="mt-0.5 h-5 w-5 text-[#1e3a8a]" />
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-[#0f172a]">{p.nome}</p>
              <p className="truncate text-xs text-slate-500">{p.indirizzo}, {p.citta}</p>
            </div>
            <button data-testid={`button-delete-property-${p.id}`} onClick={() => remove(p.id)} className="text-slate-400 hover:text-[#dc2626]" title="Rimuovi"><Trash2 className="h-4 w-4" /></button>
          </li>
        ))}
      </ul>
    </section>
  );
};
